import { styled } from '@linaria/react';
import { Button, Modal, TextInput } from '@mantine/core';
import i18n from '../../../../base-dictionary';
import { Text } from '../../../../ui-library/typography/typography';
import { useCreatePresentation } from './presentation-modal.hooks';
import type { PresentationModalProps } from './presentation-modal.type';

export const PresentationModal = ({ opened, onClose, initiativeIds, initiativesCount }: PresentationModalProps) => {
  const {
    presentationName,
    setPresentationName,
    isCreatingPresentation,
    hasGoogleCreds,
    createPresentation,
    getGoogleAuthUrl,
  } = useCreatePresentation(initiativeIds);

  const handleSubmit = async () => {
    if (!presentationName) return;

    try {
      const presentationUrl = await createPresentation();

      window.alert(i18n.t('strategy.initiatives.presentation.created_success', { name: presentationName }));
      window.open(presentationUrl, '_blank', 'noopener, noreferrer');

      onClose();
      setPresentationName('');
    } catch (error) {
      window.alert(
        i18n.t('strategy.initiatives.presentation.creation_error', {
          error: error instanceof Error ? error.message : 'Failed to create presentation',
        }),
      );
    }
  };
  return (
    <Modal opened={opened} onClose={onClose} title={i18n.t('strategy.initiatives.presentation.title')} size="md">
      <ModalContent>
        {!hasGoogleCreds && (
          <Text color="red" size="small">
            {i18n.t('strategy.initiatives.presentation.auth_required')}
          </Text>
        )}

        <TextInput
          label={i18n.t('strategy.initiatives.presentation.name_label')}
          placeholder={i18n.t('strategy.initiatives.presentation.name_placeholder')}
          value={presentationName}
          onChange={(e) => setPresentationName(e.currentTarget.value)}
          required
        />

        <Text size="small">
          {i18n.t(`strategy.initiatives.presentation.will_create${initiativesCount !== 1 ? '_plural' : ''}`, {
            count: initiativesCount,
          })}
        </Text>

        <ButtonContainer>
          {!hasGoogleCreds && (
            <Button
              variant="outline"
              onClick={() => {
                window.location.href = getGoogleAuthUrl();
              }}
            >
              {i18n.t('strategy.initiatives.presentation.connect_google')}
            </Button>
          )}
          <Button variant="outline" onClick={onClose}>
            {i18n.t('common.actions.cancel')}
          </Button>
          <Button
            loading={isCreatingPresentation}
            disabled={!presentationName || !hasGoogleCreds}
            onClick={handleSubmit}
          >
            {i18n.t('common.actions.create')}
          </Button>
        </ButtonContainer>
      </ModalContent>
    </Modal>
  );
};

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
`;
